import { CSRF_TOKEN_KEY, FE_ERROR_403_PATH, FE_SIGNIN_PATH, Require } from 'common/constants'
import { handlePermissionByFeatureId } from 'common/helpers/permission-helper'
import { isEqual } from 'lodash'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { changeLocation } from 'store/app/actions'
import { fetchCurrentOffice, getUserInfo } from 'store/session/actions'
import { getUserInfoSelector, selectUserPermission } from 'store/session/selectors'
import { fetchTerms } from 'store/settings/accountingPeriod/actions'
import { selectTermsList } from 'store/settings/accountingPeriod/selectors'

import { findNavItemByPath, getRouteBasedPermission, hasSpecialFeaturePermission, isPermissionDenied } from './helper'

export const checkPermission = (path: string, userPermissions: any, require?: Require) => {
  const selectedNavItem = findNavItemByPath(path)
  const featureId = selectedNavItem?.feature_id

  if (!userPermissions || !featureId) {
    return true
  }

  if (hasSpecialFeaturePermission(featureId, userPermissions)) {
    return true
  }

  if (isPermissionDenied(featureId, userPermissions)) {
    return false
  }

  const permission = handlePermissionByFeatureId(featureId as number, userPermissions)

  if (require) {
    return permission[require]
  }

  return getRouteBasedPermission(path, permission)
}

type PropsType = { require?: Require } & RouteProps
const PrivateRoute: React.FC<PropsType> = ({ require, ...props }) => {
  const csrfToken = localStorage.getItem(CSRF_TOKEN_KEY)

  const userInfo = useSelector(getUserInfoSelector)
  const { data: userPermissions } = useSelector(selectUserPermission)
  const dispatch = useDispatch()

  const { path }: any = props

  const isValidPermission = useMemo(() => {
    return checkPermission(path, userPermissions, require)
  }, [path, userPermissions, require])

  useEffect(() => {
    if (!csrfToken) return

    !userInfo && dispatch(getUserInfo())

    dispatch(fetchCurrentOffice())
    dispatch(fetchTerms())
  }, [dispatch, csrfToken, userInfo])

  const termsLength = useSelector(selectTermsList, isEqual)?.data?.length
  useEffect(() => {
    if (termsLength === 0) {
      dispatch(changeLocation('/accounting-periods/create'))
    }
  }, [termsLength, dispatch])

  if (csrfToken) {
    return isValidPermission ? <Route {...props} /> : <Redirect to={FE_ERROR_403_PATH} />
  }
  return <Redirect to={FE_SIGNIN_PATH} />
}

export default PrivateRoute
